export function buildFooter(config) {
  const footer = document.createElement('div');

  if (config.bookmarks) {
    const bookmarksText = "<strong>Bookmarks</strong>: " +
      config.chapters
        .filter(ch => ch.title)
        .map(ch => `<a href="#${ch.id}">${ch.title}</a>`)
        .join(" | ");

    const footerBookmarks = document.createElement('p');
    footerBookmarks.innerHTML = bookmarksText;
    footer.appendChild(footerBookmarks);
  }

  if (config.footer) {
    const footerText = document.createElement('p');
    footerText.innerHTML = config.footer;
    footer.appendChild(footerText);
  }

  if (footer.innerText.trim().length === 0) return null;

  footer.classList.add(config.theme);
  footer.id = 'footer';
  return footer;
}


